export default "__VITE_ASSET__D3ZgdtWf__"